import config from '@haaretz/l-config';

const servletUrl = config.get('servlet');
const alertsUrl = config.get('alertsUri');
const ssoUrl = config.get('sso');
const personalizationUrl = config.get('personalization');
const gamesUrl = config.get('games');
const msPurchaseUrl = config.get('msPurchase');

export const COMMENTS_URL = `${servletUrl}/comments`;
export const SITE_USER_URL = `${servletUrl}/siteUser`;

export const ALERTS_UNSUBSCRIBE_URL = `${alertsUrl}/unsubscribe`;
export const ALERTS_REGISTERED_URL = `${alertsUrl}/register`;
export const USER_RECOMMENDATIONS = `${alertsUrl}/user-recommendations`;
export const USER_ADVERTISE = `${msPurchaseUrl}/genericForm`;
export const USER_REGISTRATION_ELEMENT = `${alertsUrl}/registration-element`;
export const USER_IS_SUBSCRIBED = `${alertsUrl}/is-subscribed`;

export const GENERATE_GIFT_TOKEN = `${personalizationUrl}/gifts/generate-token`;

export const UPDATE_USER = `${ssoUrl}/updateUserData`;
export const USER_LOGIN = `${ssoUrl}/loginUrlEncoded`;
export const USER_LOGOUT = `${ssoUrl}/logout`;
export const USER_REGISTRATION = `${ssoUrl}/register`;
export const USER_REGISTRATION_ENCODED = `${ssoUrl}/registerUrlEncoded`;
export const USER_FORGOT_PASSWORD = `${ssoUrl}/resetPassword`;
export const USER_ACCEPT_PASSWORD = `${ssoUrl}/acceptResetPassword`;
export const REQUEST_LOGIN_WITHOUT_PASSWORD = `${ssoUrl}/requestLoginWithoutPassword`;
export const REQUEST_LOGIN_WITHOUT_PASSWORD_CONFIRMATION = `${ssoUrl}/requestLoginWithoutPasswordConfirmation`;

export const PERSONALIZATION_URL = `${servletUrl}/personalization`;

export const GAME_GET_DAILY_REMINDER = `${gamesUrl}/newsletter/registration-element-needed`;

export const REVERSE_CANCELLATION = `${msPurchaseUrl}/reverseCancellation`;

export const META_CONVERSION_API = '/api/meta-conversion';
